export const MAX_CONTENT_WIDTH = '1524px';

export const MAX_CONTENT_SCREEN_WIDTH = `calc(${MAX_CONTENT_WIDTH} + 48px + 48px)`;
